import React from 'react';
import './styles/Projects.css';
// Import the video file
import taskManagementVideo from '../assets/projects/videos/portfolio-screen-20250502-052215.mp4';
import taskManagementImg from '../assets/projects/images/photo_tap.jpg';
import simpliSMSImg from '../assets/projects/images/Screenshot 2025-05-02 112423.png'
import woteDeliverImg from '../assets/projects/images/Screenshot 2025-05-02 120557.png'
import ptf from '../assets/projects/images/Screenshot 2025-05-02 132226.png';
import encore from '../assets/projects/images/Screenshot 2025-05-02 141501.png';
import pos from '../assets/projects/images/Screenshot 2025-05-02 144632.png';

const Projects = () => {
  const projects = [
    {
        id: 1,
        title: 'Wote Deliver Dashboard',
        description: 'A fully responsive platform built with Angular and with full analytics from customers and restaurants on wote food mobile app.',
        image: woteDeliverImg,
        technologies: ['Angular', 'MongoDB', 'golang', 'Rest API'],
        liveLink: 'https://wote-admin.vercel.app/',
        githubLink: 'https://github.com/T-Phage/ng-host',
    },
    {
        id: 2,
        title: 'Simpli-SMS',
        description: 'A fully responsive platform built with Angular and with full analytics from handle bank trasanctions and sms api integration.',
        image: simpliSMSImg,
        technologies: ['Angular', 'MongoDB', 'Typescript', 'Rest API', 'GCP'],
        // liveLink: 'https://simpli-frontend-lake.vercel.app/',
        liveLink: 'https://simpli-sms.web.app/',
        githubLink: 'https://github.com/T-Phage/simpli-frontend',
    },
    {
      id: 3,
      title: 'ST-power Rest API',
      description: 'A full Restful APIs built with golang powered by endpoints for charging stations locator mobile app.',
      image: encore,
      technologies: ['Golang', 'Encore', 'MongoDB', 'Rest API', 'GCP'],
      videoSrc: '', // Convert liveLink to videoSrc for consistency
      githubLink: 'https://github.com/T-Phage/st-power-backend',
    },
    {
      id: 4,
      title: 'Task Management App',
      description: 'A productivity application that helps music groups organize and track their daily activities and ministrations.',
      image: taskManagementImg,
      technologies: ['Flutter', 'Firebase', 'Golang', 'Firestore', 'Rest API', 'GCM'],
      videoSrc: taskManagementVideo, // Use the imported video
      githubLink: 'https://github.com',
    },
    {
        id: 5,
        title: 'Point of Sale',
        description: 'A productivity point of sale software with full product purchase analytics.',
        image: pos,
        technologies: ['PHP', 'CSS', 'Angular', 'SQL', 'Electron'],
        videoSrc: '',
        githubLink: 'https://github.com',
    },
    {
      id: 6,
      title: 'Portfolio Website',
      description: 'A personal portfolio website to showcase my projects and skills (this website).',
      image: ptf,
      technologies: ['React', 'CSS', 'React Router'],
      liveLink: '',
      githubLink: 'https://github.com/T-Phage/MyPortfolio',
    },
  ];

  return (
    <section id="projects" className="projects-section">
      <div className="container">
        <h2 className="section-title">My Projects</h2>
        <div className="projects-grid">
          {projects.map((project) => (
            <div className="project-card" key={project.id}>
              <div className="project-img">
                {project.videoSrc ? (
                  <>
                    <img 
                      src={project.image || 'https://via.placeholder.com/600x400?text=Video+Demo+Available'} 
                      alt={project.title}
                      style={{width: '100%', height: '100%', objectFit: 'cover'}}
                    />
                    <div className="video-container" id={`video-container-${project.id}`} style={{display: 'none', position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.9)', zIndex: 10, padding: '10px'}}>
                      <button 
                        onClick={() => {
                          const container = document.querySelector(`#video-container-${project.id}`);
                          const video = document.querySelector(`#video-${project.id}`);
                          if (container) container.style.display = 'none';
                          if (video) video.pause();
                        }}
                        className="close-btn"
                      >
                        ✕
                      </button>
                      <video 
                        id={`video-${project.id}`} 
                        controls 
                        width="100%" 
                        style={{width: '100%', height: '100%', objectFit: 'contain'}}
                      >
                      <source src={project.videoSrc} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                    </div>
                  </>
                ) : project.image ? (
                  <img src={project.image} alt={project.title} />
                ) : (
                  <img src={'https://via.placeholder.com/600x400?text=Project+Preview'} alt={project.title} />
                )}
              </div>
              <div className="project-info">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <div className="project-tech">
                  {project.technologies.map((tech, index) => (
                    <span key={index} className="tech-tag">{tech}</span>
                  ))}
                </div>
                <div className="project-links">
                  {project.videoSrc && (
                    <button 
                      onClick={() => {
                        const container = document.querySelector(`#video-container-${project.id}`);
                        const videoElement = document.querySelector(`#video-${project.id}`);
                        if (container) {
                          container.style.display = 'block';
                        }
                        if (videoElement) {
                          videoElement.play();
                        }
                      }} 
                      className="btn project-btn"
                    >
                      Watch Demo
                    </button>
                  )}
                  {project.liveLink && (
                    <a href={project.liveLink} target="_blank" rel="noopener noreferrer" className="btn project-btn">View Project</a>
                  )}
                  {project.githubLink && (
                    <a href={project.githubLink} target="_blank" rel="noopener noreferrer" className="btn project-btn">GitHub</a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;